import type * as React from "react";
import { cn } from "cn";

/**
 * A placeholder in the shape of what is loading: a muted block with a soft light sweeping across
 * it. Size and corner it like the thing it stands for (a 28px circle for an avatar, a short bar
 * for a line of text), so the page keeps its layout when the content lands.
 *
 * Decorative. Put the skeletons inside one element that says what is loading, for example
 * `<output aria-label="Loading accounts">`, with the same words in an `sr-only` span. Under
 * reduced motion the sweep stops and the block holds still.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="skeleton"
      aria-hidden="true"
      className={cn("skeleton block rounded-[5px]", className)}
      {...props}
    />
  );
}

export { Skeleton };
